(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["age-verification"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('age-verification')) {
    customElements.define(
      'age-verification',
      class AgeVerification extends HTMLElement {
        static key = 'age-verified';

        connectedCallback() {
          this.querySelector('[data-age-approve]')?.addEventListener('click', () => this.approve());
          this.querySelector('[data-age-decline]')?.addEventListener('click', () => this.showStep('declined'));

          if (this.hasAttribute('data-design-mode')) {
            const section = this.closest('.shopify-section');
            document.addEventListener('shopify:section:select', (event) => {
              if (event.target === section) this.open();
            });
            document.addEventListener('shopify:section:deselect', (event) => {
              if (event.target === section) this.close();
            });
            return;
          }
          if (!this.isVerified()) this.open();
        }

        isVerified() {
          try {
            const until = Number(localStorage.getItem(AgeVerification.key));
            return until > Date.now();
          } catch (error) {
            return false;
          }
        }

        approve() {
          const days = Number(this.dataset.days) || 30;
          try {
            localStorage.setItem(AgeVerification.key, String(Date.now() + days * 86400000));
          } catch (error) {
            /* storage unavailable: the gate shows again next visit */
          }
          this.close();
        }

        showStep(name) {
          this.querySelectorAll('[data-step]').forEach((step) => (step.hidden = step.dataset.step !== name));
        }

        open() {
          this.showStep('question');
          this.hidden = false;
          document.body.classList.add('is-locked');
          this.querySelector('[data-age-approve]')?.focus();
        }

        close() {
          this.hidden = true;
          if (!document.querySelector('dialog[open]')) document.body.classList.remove('is-locked');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('article-products')) {
    customElements.define(
      'article-products',
      class ArticleProducts extends HTMLElement {
        connectedCallback() {
          this.key = 'article-products-collapsed';
          const mobile = window.matchMedia('(max-width: 749px)').matches;
          let collapsed = !this.hasAttribute(mobile ? 'data-start-open-mobile' : 'data-start-open');
          try {
            const stored = sessionStorage.getItem(this.key);
            if (stored !== null) collapsed = stored === '1';
          } catch (error) {
            /* storage unavailable */
          }
          this.setCollapsed(collapsed, false);
          this.querySelector('[data-open]').addEventListener('click', () => this.setCollapsed(false));
          this.querySelector('[data-close]').addEventListener('click', () => this.setCollapsed(true));
          this.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') this.setCollapsed(true);
          });

          if (this.hasAttribute('data-design-mode')) {
            this.classList.add('is-visible');
            return;
          }
          this.content = document.querySelector('.main-article__content') || document.querySelector('.main-article');
          this.footer = document.querySelector('.footer');
          this.onScroll = () => {
            cancelAnimationFrame(this.frame);
            this.frame = requestAnimationFrame(() => this.update());
          };
          window.addEventListener('scroll', this.onScroll, { passive: true });
          this.update();
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.onScroll);
        }

        update() {
          const reveal = Number(this.dataset.reveal || 30) / 100;
          let passed = false;
          if (this.content) {
            const rect = this.content.getBoundingClientRect();
            const progress = (window.innerHeight - rect.top) / Math.max(rect.height, 1);
            passed = progress >= reveal;
          }
          const footerVisible = this.footer ? this.footer.getBoundingClientRect().top < window.innerHeight : false;
          this.classList.toggle('is-visible', passed && !footerVisible);
        }

        setCollapsed(collapsed, remember = true) {
          this.classList.toggle('is-collapsed', collapsed);
          this.querySelector('[data-open]').setAttribute('aria-expanded', collapsed ? 'false' : 'true');
          if (!remember) return;
          try {
            sessionStorage.setItem(this.key, collapsed ? '1' : '0');
          } catch (error) {
            /* storage unavailable */
          }
          if (!collapsed) this.querySelector('[data-close]').focus();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('before-after')) {
    customElements.define(
      'before-after',
      class BeforeAfter extends HTMLElement {
        connectedCallback() {
          const input = this.querySelector('input');
          input.addEventListener('input', () => this.style.setProperty('--pos', `${input.value}%`));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["card-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('card-carousel')) {
    customElements.define(
      'card-carousel',
      class CardCarousel extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          this.cards = [...this.querySelectorAll('[data-card]')];
          this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(-1));
          this.querySelector('[data-next]')?.addEventListener('click', () => this.go(1));
          this.track.addEventListener('scroll', () => requestAnimationFrame(() => this.update()), { passive: true });
          this.addEventListener('shopify:block:select', (event) => this.center(this.cards.indexOf(event.target)));
          new ResizeObserver(() => this.update()).observe(this.track);
          requestAnimationFrame(() => this.center(Math.floor((this.cards.length - 1) / 2), 'instant'));
        }

        current() {
          const mid = this.track.scrollLeft + this.track.clientWidth / 2;
          let best = 0;
          this.cards.forEach((card, i) => {
            const a = Math.abs(card.offsetLeft + card.offsetWidth / 2 - mid);
            const b = Math.abs(this.cards[best].offsetLeft + this.cards[best].offsetWidth / 2 - mid);
            if (a < b) best = i;
          });
          return best;
        }

        go(direction) {
          this.center(Math.min(Math.max(this.current() + direction, 0), this.cards.length - 1));
        }

        center(i, behavior = 'smooth') {
          const card = this.cards[i];
          if (!card) return;
          this.track.scrollTo({ left: card.offsetLeft + card.offsetWidth / 2 - this.track.clientWidth / 2, behavior });
        }

        update() {
          const mid = this.track.scrollLeft + this.track.clientWidth / 2;
          this.cards.forEach((card) => {
            const distance = Math.abs(card.offsetLeft + card.offsetWidth / 2 - mid) / (card.offsetWidth || 1);
            card.style.setProperty('--d', distance.toFixed(3));
          });
          const i = this.current();
          const prev = this.querySelector('[data-prev]');
          const next = this.querySelector('[data-next]');
          if (prev) prev.disabled = i === 0;
          if (next) next.disabled = i === this.cards.length - 1;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('faq-accordion')) {
    customElements.define(
      'faq-accordion',
      class FaqAccordion extends HTMLElement {
        connectedCallback() {
          this.addEventListener('click', (event) => {
            const item = event.target.closest('.faq__item');
            if (!item || event.target.closest('.faq__answer a')) return;
            this.toggle(item);
          });
          this.addEventListener('shopify:block:select', (event) => {
            if (!event.target.classList.contains('is-open')) this.toggle(event.target);
          });
        }

        toggle(item) {
          const button = item.querySelector('.faq__question');
          const answer = item.querySelector('.faq__answer');
          const open = !item.classList.contains('is-open');
          item.classList.toggle('is-open', open);
          button.setAttribute('aria-expanded', open);
          answer.getAnimations().forEach((animation) => animation.cancel());
          if (open) {
            answer.hidden = false;
            const height = answer.scrollHeight;
            answer.animate(
              [
                { height: '0px', opacity: 0 },
                { height: `${height}px`, opacity: 1 },
              ],
              { duration: 300, easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)' }
            );
          } else {
            const height = answer.scrollHeight;
            answer
              .animate(
                [
                  { height: `${height}px`, opacity: 1 },
                  { height: '0px', opacity: 0 },
                ],
                { duration: 300, easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)' }
              )
              .finished.then(() => {
                if (!item.classList.contains('is-open')) answer.hidden = true;
              })
              .catch(() => {});
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (() => {
    const query = window.matchMedia('(min-width: 990px)');
    const sync = () => {
      document.querySelectorAll('[data-footer-accordion]').forEach((details) => {
        details.open = query.matches;
      });
    };
    sync();
    query.addEventListener('change', sync);
    document.addEventListener('shopify:section:load', sync);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const closer = event.target.closest('[data-details-close]');
    if (closer) closer.closest('details')?.removeAttribute('open');
    document.querySelectorAll('.header__settings[open]').forEach((details) => {
      if (!details.contains(event.target)) details.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.header__settings[open]').forEach((details) => {
      details.removeAttribute('open');
      details.querySelector('summary')?.focus();
    });
  });
  if (!customElements.get('header-menu')) {
    customElements.define(
      'header-menu',
      class HeaderMenu extends HTMLElement {
        connectedCallback() {
          this.items = [...this.querySelectorAll('[data-menu-item]')];
          this.items.forEach((item) => {
            const trigger = item.querySelector('[data-menu-trigger]');
            item.addEventListener('pointerenter', (event) => {
              if (event.pointerType === 'mouse') this.open(item);
            });
            item.addEventListener('pointerleave', (event) => {
              if (event.pointerType === 'mouse' && this.pinned !== item) this.close(item, 300);
            });
            item.addEventListener('focusout', (event) => {
              if (!item.contains(event.relatedTarget) && this.pinned !== item) this.close(item);
            });
            trigger.addEventListener('click', (event) => {
              if (!item.classList.contains('is-open')) {
                event.preventDefault();
                this.open(item);
              } else if (!this.hasAttribute('data-top-link') || event.pointerType !== 'mouse') {
                event.preventDefault();
                this.close(item);
              }
            });
          });
          this.onKeydown = (event) => {
            if (event.key !== 'Escape') return;
            const item = this.items.find((entry) => entry.classList.contains('is-open'));
            if (!item) return;
            this.close(item);
            item.querySelector('[data-menu-trigger]').focus();
          };
          this.onDocumentClick = (event) => {
            if (!this.contains(event.target)) this.items.forEach((item) => this.pinned !== item && this.close(item));
          };
          this.onBlockSelect = (event) => {
            const item = event.target.closest?.('[data-menu-item]');
            if (!item || !this.contains(item)) return;
            this.pinned = item;
            this.open(item);
          };
          this.onBlockDeselect = (event) => {
            const item = event.target.closest?.('[data-menu-item]');
            if (!item || this.pinned !== item) return;
            this.pinned = null;
            this.close(item);
          };
          document.addEventListener('keydown', this.onKeydown);
          document.addEventListener('click', this.onDocumentClick);
          document.addEventListener('shopify:block:select', this.onBlockSelect);
          document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
        }

        disconnectedCallback() {
          document.removeEventListener('keydown', this.onKeydown);
          document.removeEventListener('click', this.onDocumentClick);
          document.removeEventListener('shopify:block:select', this.onBlockSelect);
          document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
        }

        open(item) {
          clearTimeout(item.closeTimer);
          this.items.forEach((other) => other !== item && this.close(other));
          item.classList.add('is-open');
          item.querySelector('[data-menu-trigger]').setAttribute('aria-expanded', 'true');
        }

        close(item, delay = 0) {
          clearTimeout(item.closeTimer);
          const hide = () => {
            item.classList.remove('is-open');
            item.querySelector('[data-menu-trigger]').setAttribute('aria-expanded', 'false');
          };
          if (delay) item.closeTimer = setTimeout(hide, delay);
          else hide();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hero-slider')) {
    customElements.define(
      'hero-slider',
      class HeroSlider extends HTMLElement {
        connectedCallback() {
          this.taglines = [...this.querySelectorAll('.hero-slider__tagline')];
          this.slides = [...this.querySelectorAll('.hero-slider__slide')];
          this.dots = [...this.querySelectorAll('[data-go]')];
          this.index = 0;
          this.interval = parseInt(this.dataset.interval, 10) || 3000;
          this.autoplay = this.dataset.autoplay === 'true' && this.slides.length > 1;
          this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(parseInt(dot.dataset.go, 10))));
          this.addEventListener('shopify:block:select', (event) => {
            const i = this.taglines.indexOf(event.target);
            if (i > -1) {
              this.autoplay = false;
              this.go(i);
            }
          });
          if (this.hasAttribute('data-pause-on-hover')) {
            const media = this.querySelector('.hero-slider__media');
            media?.addEventListener('pointerenter', () => {
              this.hovered = true;
              cancelAnimationFrame(this.frame);
            });
            media?.addEventListener('pointerleave', () => {
              this.hovered = false;
              if (this.inView) this.startTimer();
            });
          }
          this.visibleObserver = new IntersectionObserver(([entry]) => {
            this.inView = entry.isIntersecting;
            if (this.inView) this.startTimer();
            else cancelAnimationFrame(this.frame);
          });
          this.visibleObserver.observe(this);
        }

        disconnectedCallback() {
          cancelAnimationFrame(this.frame);
          this.visibleObserver?.disconnect();
        }

        startTimer() {
          cancelAnimationFrame(this.frame);
          if (this.hovered) return;
          if (!this.autoplay || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            this.setProgress(1);
            return;
          }
          const started = performance.now() - (this.elapsed || 0);
          const tick = (now) => {
            this.elapsed = now - started;
            const progress = Math.min(1, this.elapsed / this.interval);
            this.setProgress(progress);
            if (progress >= 1) {
              this.elapsed = 0;
              this.go((this.index + 1) % this.slides.length, true);
              return;
            }
            this.frame = requestAnimationFrame(tick);
          };
          this.frame = requestAnimationFrame(tick);
        }

        setProgress(value) {
          this.dots[this.index]?.style.setProperty('--progress', value);
        }

        slideTagline(from, to, forward) {
          if (!from || !to) return;
          [from, to].forEach((el) => el.getAnimations().forEach((animation) => animation.cancel()));
          from.classList.remove('is-active');
          to.classList.add('is-active');
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          const timing = { duration: 800, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' };
          from.classList.add('is-animating');
          from
            .animate([{ translate: '0 0' }, { translate: forward ? '0 -100%' : '0 100%' }], timing)
            .finished.then(() => from.classList.remove('is-animating'))
            .catch(() => from.classList.remove('is-animating'));
          to.animate([{ translate: forward ? '0 100%' : '0 -100%' }, { translate: '0 0' }], timing);
        }

        async go(next, forward = next > this.index) {
          if (next === this.index || this.busy) return;
          cancelAnimationFrame(this.frame);
          const prev = this.index;
          const from = this.slides[prev];
          const to = this.slides[next];
          this.busy = true;
          this.index = next;
          this.elapsed = 0;
          this.slideTagline(this.taglines[prev], this.taglines[next], forward);
          this.dots.forEach((dot, i) => {
            dot.setAttribute('aria-current', i === next ? 'true' : 'false');
            dot.style.setProperty('--progress', 0);
          });
          from.classList.add('is-animating');
          to.classList.add('is-animating', 'is-active');
          await window.theme?.creativeSlide?.(from, to, forward, 800);
          from.classList.remove('is-active', 'is-animating');
          to.classList.remove('is-animating');
          this.busy = false;
          if (this.inView) this.startTimer();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('image-tabs')) {
    customElements.define(
      'image-tabs',
      class ImageTabs extends HTMLElement {
        connectedCallback() {
          this.tabs = [...this.querySelectorAll('[data-tab]')];
          this.panels = [...this.querySelectorAll('[data-panel]')];
          const hover = window.matchMedia('(hover: hover) and (pointer: fine)');
          this.tabs.forEach((tab, i) => {
            tab.addEventListener('mouseenter', () => hover.matches && this.select(i));
            tab.addEventListener('focus', () => this.select(i));
            tab.addEventListener('click', (event) => {
              if (tab.getAttribute('href') === '#' || tab.getAttribute('aria-current') !== 'true') {
                event.preventDefault();
                this.select(i);
              }
            });
          });
          this.addEventListener('shopify:block:select', (event) => {
            const i = this.tabs.findIndex((tab) => event.target.contains(tab));
            if (i > -1) this.select(i);
          });
        }

        select(i) {
          this.tabs.forEach((tab, n) => tab.setAttribute('aria-current', n === i ? 'true' : 'false'));
          this.panels.forEach((panel, n) => panel.classList.toggle('is-active', n === i));
          this.tabs[i].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  if (!customElements.get('price-range')) {
    customElements.define(
      'price-range',
      class PriceRange extends HTMLElement {
        connectedCallback() {
          this.max = Number(this.dataset.max) || 0;
          this.minInput = this.querySelector('[data-price-min]');
          this.maxInput = this.querySelector('[data-price-max]');
          this.minRange = this.querySelector('[data-range-min]');
          this.maxRange = this.querySelector('[data-range-max]');
          this.track = this.querySelector('[data-range]');
          this.minRange.addEventListener('input', () => this.fromRange('min'));
          this.maxRange.addEventListener('input', () => this.fromRange('max'));
          this.minInput.addEventListener('input', () => this.fromField());
          this.maxInput.addEventListener('input', () => this.fromField());
          this.paint();
        }

        fromRange(changed) {
          let min = Number(this.minRange.value);
          let max = Number(this.maxRange.value);
          if (min > max) {
            if (changed === 'min') min = max;
            else max = min;
            this.minRange.value = min;
            this.maxRange.value = max;
          }
          this.minInput.value = min > 0 ? min : '';
          this.maxInput.value = max < this.max ? max : '';
          this.paint();
        }

        fromField() {
          this.minRange.value = Number(this.minInput.value) || 0;
          this.maxRange.value = this.maxInput.value === '' ? this.max : Number(this.maxInput.value);
          this.paint();
        }

        paint() {
          if (!this.max) return;
          this.track.style.setProperty('--range-min', `${(Number(this.minRange.value) / this.max) * 100}%`);
          this.track.style.setProperty('--range-max', `${(Number(this.maxRange.value) / this.max) * 100}%`);
        }
      }
    );
  }

  if (!customElements.get('collection-facets')) {
    customElements.define(
      'collection-facets',
      class CollectionFacets extends HTMLElement {
        connectedCallback() {
          this.sectionId = this.dataset.sectionId;
          this.form = this.querySelector('[data-facets-form]');
          this.form?.addEventListener('submit', (event) => {
            event.preventDefault();
            this.close();
            this.render(this.buildUrl());
          });
          this.addEventListener('click', (event) => {
            const link = event.target.closest('[data-facet-link]');
            if (link) {
              event.preventDefault();
              this.render(link.getAttribute('href'));
              return;
            }
            const more = event.target.closest('[data-load-more]');
            if (more) {
              event.preventDefault();
              this.loadMore(more);
              return;
            }
            if (event.target.closest('[data-facets-clear]')) {
              event.preventDefault();
              this.close();
              const url = new URL(this.dataset.url, window.location.origin);
              const sort = new URLSearchParams(window.location.search).get('sort_by');
              if (sort) url.searchParams.set('sort_by', sort);
              this.render(url.pathname + url.search);
            }
          });
          this.querySelector('[data-sort-options]')?.addEventListener('change', (event) => {
            if (event.target.name !== 'sort_by') return;
            const url = new URL(window.location.href);
            url.searchParams.set('sort_by', event.target.value);
            url.searchParams.delete('page');
            this.close();
            this.render(url.pathname + url.search);
          });
          window.addEventListener('popstate', () => this.render(window.location.pathname + window.location.search, false));
        }

        close() {
          this.querySelectorAll('dialog[open]').forEach((dialog) => dialog.close());
        }

        buildUrl() {
          const params = new URLSearchParams();
          new FormData(this.form).forEach((value, key) => {
            if (value !== '') params.append(key, value);
          });
          const sort = new URLSearchParams(window.location.search).get('sort_by');
          if (sort) params.set('sort_by', sort);
          const query = params.toString();
          return `${this.dataset.url}${query ? `?${query}` : ''}`;
        }

        async fetchSection(url) {
          const target = new URL(url, window.location.origin);
          target.searchParams.set('section_id', this.sectionId);
          const response = await fetch(target);
          return new DOMParser().parseFromString(await response.text(), 'text/html');
        }

        async render(url, push = true) {
          const wrap = this.querySelector('[data-grid-wrap]');
          wrap.classList.add('is-loading');
          try {
            const html = await this.fetchSection(url);
            const fresh = html.querySelector('collection-facets');
            if (!fresh) throw new Error('missing');
            ['[data-active-facets]', '[data-grid-wrap]', '[data-facets-body]', '[data-filter-count]', '[data-sort-options]'].forEach((selector) => {
              const current = this.querySelector(selector);
              const next = fresh.querySelector(selector);
              if (current && next) current.replaceWith(next);
            });
            this.querySelector('[data-sort-options]')?.addEventListener('change', (event) => {
              if (event.target.name !== 'sort_by') return;
              const next = new URL(window.location.href);
              next.searchParams.set('sort_by', event.target.value);
              next.searchParams.delete('page');
              this.close();
              this.render(next.pathname + next.search);
            });
            if (push) window.history.pushState({}, '', url);
          } catch (error) {
            window.location.href = url;
          } finally {
            this.querySelector('[data-grid-wrap]')?.classList.remove('is-loading');
          }
        }

        async loadMore(button) {
          button.setAttribute('aria-busy', 'true');
          try {
            const html = await this.fetchSection(button.getAttribute('href'));
            const items = html.querySelectorAll('[data-grid] > li');
            this.querySelector('[data-grid]')?.append(...items);
            const nextWrap = html.querySelector('[data-load-more-wrap]');
            this.querySelector('[data-load-more-wrap]')?.replaceWith(nextWrap);
          } catch (error) {
            window.location.href = button.getAttribute('href');
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  {
    const hashTarget = location.hash.length > 1 ? document.getElementById(location.hash.slice(1)) : null;
    const hashDialog = hashTarget?.closest('dialog.product-dialog');
    if (hashDialog && !hashDialog.open) hashDialog.showModal();
  }
  document.addEventListener(
    'toggle',
    (event) => {
      if (!event.target.matches?.('.gift-recipient')) return;
      const toggle = event.target.querySelector('input[type="checkbox"]');
      if (toggle) toggle.checked = event.target.open;
    },
    true
  );
  if (!customElements.get('product-gallery')) {
    customElements.define(
      'product-gallery',
      class ProductGallery extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          this.slides = [...this.track.children];
          this.thumbs = [...this.querySelectorAll('[data-thumb]')];
          this.thumbsWrap = this.querySelector('[data-thumbs]');
          this.dots = [...this.querySelectorAll('[data-dot]')];
          this.prev = this.querySelector('[data-prev]');
          this.next = this.querySelector('[data-next]');
          this.index = Number(this.dataset.start) || 0;

          this.thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => this.goTo(i)));
          this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.goTo(i)));
          this.prev?.addEventListener('click', () => this.goTo(this.index - 1));
          this.next?.addEventListener('click', () => this.goTo(this.index + 1));
          this.track.addEventListener('scroll', () => this.onScroll(), { passive: true });
          if (this.hasAttribute('data-zoom-desktop') || this.hasAttribute('data-zoom-mobile')) this.setupZoom();
          if (this.index > 0) requestAnimationFrame(() => this.goTo(this.index, false));
          this.update();
        }

        setupZoom() {
          const desktop = window.matchMedia('(min-width: 990px)');
          const dialog = this.querySelector('[data-zoom-dialog]');
          this.slides.forEach((slide) => {
            if (!slide.dataset.zoomSrc) return;
            const image = slide.querySelector('img');
            slide.addEventListener('pointermove', (event) => {
              if (!desktop.matches || !this.hasAttribute('data-zoom-desktop') || event.pointerType !== 'mouse') return;
              const rect = slide.getBoundingClientRect();
              image.style.transformOrigin = `${((event.clientX - rect.left) / rect.width) * 100}% ${((event.clientY - rect.top) / rect.height) * 100}%`;
              slide.classList.add('is-zooming');
            });
            slide.addEventListener('pointerleave', () => slide.classList.remove('is-zooming'));
            slide.addEventListener('click', () => {
              if (desktop.matches || !dialog) return;
              const zoomImage = dialog.querySelector('img') || dialog.appendChild(document.createElement('img'));
              zoomImage.alt = image.alt;
              zoomImage.src = slide.dataset.zoomSrc;
              dialog.showModal();
            });
          });
        }

        isScrollable() {
          return this.track.scrollWidth > this.track.clientWidth + 2;
        }

        goTo(i, smooth = true) {
          if (!this.slides.length) return;
          const index = Math.max(0, Math.min(i, this.slides.length - 1));
          if (this.isScrollable()) {
            this.track.scrollTo({ left: this.slides[index].offsetLeft - this.track.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
          } else if (smooth && index !== this.index) {
            this.slides[index].scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
          this.index = index;
          this.update();
        }

        goToMedia(mediaId) {
          const index = this.slides.findIndex((slide) => slide.dataset.mediaId === String(mediaId));
          if (index > -1) this.goTo(index);
        }

        onScroll() {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => {
            const width = this.slides[0]?.offsetWidth || 1;
            const index = Math.round(this.track.scrollLeft / (width + 16));
            if (index === this.index) return;
            this.index = index;
            this.update();
          });
        }

        update() {
          this.thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', i === this.index ? 'true' : 'false'));
          this.dots.forEach((dot, i) => dot.setAttribute('aria-current', i === this.index ? 'true' : 'false'));
          if (this.prev) this.prev.disabled = this.index === 0;
          if (this.next) this.next.disabled = this.index === this.slides.length - 1;
          const thumb = this.thumbs[this.index];
          if (thumb && this.thumbsWrap && this.thumbsWrap.scrollHeight > this.thumbsWrap.clientHeight) {
            this.thumbsWrap.scrollTo({ top: thumb.offsetTop - (this.thumbsWrap.clientHeight - thumb.offsetHeight) / 2, behavior: 'smooth' });
          }
        }
      }
    );
  }

  if (!customElements.get('product-info')) {
    customElements.define(
      'product-info',
      class ProductInfo extends HTMLElement {
        connectedCallback() {
          this.variants = JSON.parse(this.querySelector('[data-variants]')?.textContent || '[]');
          this.gallery = this.querySelector('product-gallery');
          this.addEventListener('change', (event) => {
            if (event.target.closest('[data-option]')) this.onOptionChange();
          });
          this.addEventListener('click', (event) => this.onClick(event));
          this.addEventListener('submit', (event) => this.onSubmit(event));
          this.loadComplementary();
        }

        onClick(event) {
          const step = event.target.closest('[data-qty-step]');
          if (step) {
            const input = step.parentElement.querySelector('input');
            input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(step.dataset.qtyStep));
            return;
          }
          const share = event.target.closest('[data-share]');
          if (share) this.share(share);
        }

        selectedOptions() {
          return [...this.querySelectorAll('[data-option]')].map((option) => (option.querySelector('input:checked') || option.querySelector('select'))?.value);
        }

        async onOptionChange() {
          const selected = this.selectedOptions();
          const variant = this.variants.find((v) => v.options.every((value, i) => value === selected[i]));
          const submit = this.querySelector('[data-submit]');
          if (!variant) {
            if (submit) {
              submit.disabled = true;
              submit.querySelectorAll('.button__label').forEach((el) => (el.textContent = theme.strings.unavailable));
            }
            return;
          }
          this.querySelectorAll('input[name="id"]').forEach((input) => (input.value = variant.id));
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
          if (variant.featured_media) this.gallery?.goToMedia(variant.featured_media.id);

          this.controller?.abort();
          this.controller = new AbortController();
          try {
            const response = await fetch(`${this.dataset.url}?variant=${variant.id}&section_id=${this.dataset.section}`, { signal: this.controller.signal });
            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            const focusedId = document.activeElement?.id;
            this.querySelectorAll('[data-update]').forEach((target) => {
              const source = html.querySelector(`[data-update="${target.dataset.update}"]`);
              if (source) target.replaceWith(source);
            });
            if (focusedId) document.getElementById(focusedId)?.focus();
          } catch (error) {
            if (error.name !== 'AbortError') window.location.href = url.toString();
          }
        }

        async onSubmit(event) {
          const form = event.target;
          if (!form.matches('[data-product-form], [data-sticky-form]')) return;
          event.preventDefault();
          const button = form.querySelector('[type="submit"]');
          const message = this.querySelector('[data-buy-message]');
          button?.setAttribute('aria-busy', 'true');
          if (message) message.hidden = true;
          const data = new FormData(form);
          if (form.matches('[data-sticky-form]')) {
            const mainForm = this.querySelector('[data-product-form]');
            if (mainForm && !mainForm.checkValidity()) {
              mainForm.reportValidity();
              button?.removeAttribute('aria-busy');
              return;
            }
            const quantity = mainForm?.querySelector('[name="quantity"]');
            if (quantity) data.set('quantity', quantity.value);
            if (mainForm) {
              new FormData(mainForm).forEach((value, key) => {
                if (key.startsWith('properties[')) data.append(key, value);
              });
            }
          }
          try {
            const added = await theme.addToCart(data);
            if (message && !added.notified) {
              message.textContent = theme.strings.added;
              message.dataset.state = 'success';
              message.hidden = false;
            }
            if (form.matches('[data-sticky-form]')) {
              button.classList.add('is-done');
              setTimeout(() => button.classList.remove('is-done'), 2000);
            }
          } catch (error) {
            if (message) {
              message.textContent = error.message || theme.strings.cartError;
              message.dataset.state = 'error';
              message.hidden = false;
              if (form.matches('[data-sticky-form]')) message.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          } finally {
            button?.removeAttribute('aria-busy');
          }
        }

        async share(button) {
          const status = button.parentElement.querySelector('[data-share-status]');
          const data = { title: document.title, url: button.dataset.url || window.location.href };
          try {
            if (navigator.share) {
              await navigator.share(data);
              return;
            }
            await navigator.clipboard.writeText(data.url);
            if (status) {
              status.textContent = theme.strings.linkCopied;
              status.hidden = false;
              setTimeout(() => (status.hidden = true), 2500);
            }
          } catch (error) {
            /* share cancelled */
          }
        }

        async loadComplementary() {
          const wrap = this.querySelector('[data-complementary]');
          if (!wrap) return;
          try {
            const response = await fetch(wrap.dataset.url);
            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            const content = html.querySelector('[data-complementary-content]');
            if (!content || !content.children.length) return;
            wrap.querySelector('[data-complementary-list]').replaceChildren(...content.children);
            wrap.hidden = false;
          } catch (error) {
            /* recommendations unavailable */
          }
        }
      }
    );
  }

  if (!customElements.get('sticky-add-bar')) {
    customElements.define(
      'sticky-add-bar',
      class StickyAddBar extends HTMLElement {
        connectedCallback() {
          const root = this.closest('product-info');
          this.buyButtons = root?.querySelector('[data-buy-buttons]');
          this.footer = document.querySelector('.footer');
          if (!this.buyButtons) return;
          this.state = new Map();
          this.observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              this.state.set(entry.target, { visible: entry.isIntersecting, above: entry.boundingClientRect.bottom < 0 });
            });
            const buy = this.state.get(this.buyButtons);
            const footer = this.footer ? this.state.get(this.footer) : null;
            this.classList.toggle('is-visible', Boolean(buy && !buy.visible && buy.above && !footer?.visible));
          });
          this.observer.observe(this.buyButtons);
          if (this.footer) this.observer.observe(this.footer);
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }
      }
    );
  }
  if (!customElements.get('content-nav')) {
    customElements.define(
      'content-nav',
      class ContentNav extends HTMLElement {
        connectedCallback() {
          const scope = this.closest('.main-product__extended') || document;
          const targets = [...scope.querySelectorAll('[data-nav-label]')].filter((target) => target.id);
          this.hidden = targets.length < 2;
          if (this.hidden) return;
          this.querySelector('ul').replaceChildren(
            ...targets.map((target) => {
              const item = document.createElement('li');
              const link = document.createElement('a');
              link.href = `#${target.id}`;
              link.className = 'product-content-nav__link';
              link.dataset.navTarget = target.id;
              link.textContent = target.dataset.navLabel;
              item.append(link);
              return item;
            })
          );
          this.links = [...this.querySelectorAll('[data-nav-target]')];
          const sections = this.links.map((link) => document.getElementById(link.dataset.navTarget)).filter(Boolean);
          this.links.forEach((link) =>
            link.addEventListener('click', (event) => {
              event.preventDefault();
              document.getElementById(link.dataset.navTarget)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
            })
          );
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) this.setCurrent(entry.target.id);
              });
            },
            { rootMargin: '-35% 0px -60% 0px' }
          );
          sections.forEach((section) => this.observer.observe(section));
          if (sections[0]) this.setCurrent(sections[0].id);
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }

        setCurrent(id) {
          this.links.forEach((link) => {
            const current = link.dataset.navTarget === id;
            link.setAttribute('aria-current', current ? 'true' : 'false');
            if (current) link.scrollIntoView({ block: 'nearest', inline: 'nearest' });
          });
        }
      }
    );
  }
  if (!customElements.get('pickup-availability')) {
    customElements.define(
      'pickup-availability',
      class PickupAvailability extends HTMLElement {
        async connectedCallback() {
          try {
            const response = await fetch(this.dataset.url);
            if (!response.ok) return;
            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            const content = html.querySelector('.product-pickup__content');
            if (!content) return;
            this.replaceChildren(content);
            this.hidden = false;
          } catch (error) {
            this.hidden = true;
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-recommendations')) {
    customElements.define(
      'product-recommendations',
      class ProductRecommendations extends HTMLElement {
        connectedCallback() {
          if (!this.querySelector('[data-recommendations-content]')) this.load();
        }

        async load() {
          try {
            const response = await fetch(this.dataset.url);
            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            const content = html.querySelector('[data-recommendations-content]');
            if (content) this.replaceChildren(content);
          } catch (error) {
            /* recommendations unavailable */
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('recently-viewed')) {
    customElements.define(
      'recently-viewed',
      class RecentlyViewed extends HTMLElement {
        async connectedCallback() {
          const exclude = this.dataset.exclude;
          const handles = (window.theme?.getRecentlyViewed?.() || [])
            .map((item) => item.h)
            .filter((handle) => handle && handle !== exclude)
            .slice(0, Number(this.dataset.limit) || 4);
          if (!handles.length) return;
          const root = window.theme?.routes?.root || '/';
          const cards = await Promise.all(
            handles.map(async (handle) => {
              try {
                const response = await fetch(`${root.replace(/\/$/, '')}/products/${handle}?view=card`);
                if (!response.ok) return null;
                const html = new DOMParser().parseFromString(await response.text(), 'text/html');
                return html.querySelector('[data-card-handle]');
              } catch (error) {
                return null;
              }
            })
          );
          const items = cards.filter(Boolean).map((card) => {
            const li = document.createElement('li');
            li.append(...card.childNodes);
            return li;
          });
          if (!items.length) return;
          this.querySelector('[data-items]').replaceChildren(...items);
          this.querySelector('[data-design-note]')?.remove();
          this.hidden = false;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('slide-show')) {
    customElements.define(
      'slide-show',
      class SlideShow extends HTMLElement {
        connectedCallback() {
          this.slides = [...this.querySelectorAll('.slideshow__slide')];
          this.dots = [...this.querySelectorAll('[data-go]')];
          this.prev = this.querySelector('[data-prev]');
          this.next = this.querySelector('[data-next]');
          this.index = 0;
          this.loop = this.hasAttribute('data-loop');
          this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.go))));
          this.prev?.addEventListener('click', () => this.step(-1));
          this.next?.addEventListener('click', () => this.step(1));
          this.addEventListener('shopify:block:select', (event) => {
            const i = this.slides.indexOf(event.target);
            if (i > -1) this.show(i);
          });
          this.updateNav();
          const delay = Number(this.dataset.autoplay);
          if (delay > 0 && this.slides.length > 1) {
            this.addEventListener('pointerenter', () => (this.paused = true));
            this.addEventListener('pointerleave', () => (this.paused = false));
            this.timer = setInterval(() => {
              if (!this.paused && !document.hidden) this.step(1, true);
            }, delay);
          }
        }

        disconnectedCallback() {
          clearInterval(this.timer);
        }

        step(direction, wrap = this.loop) {
          let target = this.index + direction;
          if (target < 0) target = wrap ? this.slides.length - 1 : 0;
          if (target >= this.slides.length) target = wrap ? 0 : this.slides.length - 1;
          this.show(target, direction > 0);
        }

        async show(i, forward = i > this.index) {
          if (i === this.index || this.busy) return;
          const from = this.slides[this.index];
          const to = this.slides[i];
          this.index = i;
          this.dots.forEach((dot, n) => dot.setAttribute('aria-current', n === i ? 'true' : 'false'));
          this.updateNav();
          from.inert = true;
          to.inert = false;
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (this.dataset.animation === 'fade' || reduce) {
            from.classList.remove('is-active');
            to.classList.add('is-active');
            return;
          }
          this.busy = true;
          from.classList.add('is-animating');
          to.classList.add('is-animating', 'is-active');
          if (this.dataset.animation === 'creative') {
            await window.theme?.creativeSlide?.(from, to, forward, 900);
          } else {
            const timing = { duration: 600, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' };
            await Promise.all([
              to.animate([{ translate: forward ? '100% 0' : '-100% 0' }, { translate: '0 0' }], timing).finished,
              from.animate([{ translate: '0 0' }, { translate: forward ? '-100% 0' : '100% 0' }], timing).finished,
            ]);
          }
          from.classList.remove('is-active', 'is-animating');
          to.classList.remove('is-animating');
          this.busy = false;
        }

        updateNav() {
          if (this.prev) this.prev.disabled = !this.loop && this.index === 0;
          if (this.next) this.next.disabled = !this.loop && this.index === this.slides.length - 1;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tabs-slider')) {
    customElements.define(
      'tabs-slider',
      class TabsSlider extends HTMLElement {
        connectedCallback() {
          this.tabs = [...this.querySelectorAll('[role="tab"]')];
          this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
          this.tablist = this.querySelector('[role="tablist"]');
          this.prev = this.querySelector('[data-prev]');
          this.next = this.querySelector('[data-next]');
          this.index = 0;
          this.busy = false;
          this.tabs.forEach((tab, i) => tab.addEventListener('click', () => this.show(i)));
          this.prev?.addEventListener('click', () => this.show(this.index - 1));
          this.next?.addEventListener('click', () => this.show(this.index + 1));
          this.tablist.addEventListener('keydown', (event) => {
            const last = this.tabs.length - 1;
            let target = null;
            if (event.key === 'ArrowRight') target = this.index === last ? 0 : this.index + 1;
            if (event.key === 'ArrowLeft') target = this.index === 0 ? last : this.index - 1;
            if (target === null) return;
            event.preventDefault();
            this.show(target, true);
          });
          this.addEventListener('shopify:block:select', (event) => {
            const i = this.panels.indexOf(event.target);
            if (i > -1) this.show(i);
          });
          this.initSwipe();
          new ResizeObserver(() => this.moveIndicator()).observe(this.tablist);
          this.updateNav();
          const delay = Number(this.dataset.autoplay);
          if (delay > 0 && this.panels.length > 1) {
            this.addEventListener('pointerenter', () => (this.paused = true));
            this.addEventListener('pointerleave', () => (this.paused = false));
            this.timer = setInterval(() => {
              if (this.paused || document.hidden) return;
              this.show(this.index === this.panels.length - 1 ? 0 : this.index + 1);
            }, delay);
          }
        }

        disconnectedCallback() {
          clearInterval(this.timer);
        }

        async show(i, focus = false) {
          if (i < 0 || i >= this.panels.length || i === this.index || this.busy) return;
          const from = this.panels[this.index];
          const to = this.panels[i];
          const forward = i > this.index;
          this.busy = true;
          this.index = i;

          this.tabs.forEach((tab, n) => {
            tab.setAttribute('aria-selected', n === i ? 'true' : 'false');
            tab.tabIndex = n === i ? 0 : -1;
          });
          if (focus) this.tabs[i].focus();
          this.tabs[i].scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
          this.moveIndicator();
          this.updateNav();

          from.classList.add('is-animating');
          to.classList.add('is-animating', 'is-active');
          to.inert = false;
          from.inert = true;
          const fromContent = from.querySelector('.tabs-slider__content');
          fromContent?.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 300, easing: 'ease', fill: 'forwards' });

          await window.theme?.creativeSlide?.(from, to, forward, 1000);

          from.classList.remove('is-active', 'is-animating');
          to.classList.remove('is-animating');
          fromContent?.getAnimations().forEach((animation) => animation.cancel());
          this.busy = false;
        }

        initSwipe() {
          const slides = this.querySelector('.tabs-slider__slides');
          const mobile = window.matchMedia('(max-width: 749px)');
          let start = null;
          slides.addEventListener(
            'touchstart',
            (event) => {
              start = mobile.matches && event.touches.length === 1 ? event.touches[0] : null;
              if (start) start = { x: start.clientX, y: start.clientY };
            },
            { passive: true }
          );
          slides.addEventListener('touchend', (event) => {
            if (!start) return;
            const touch = event.changedTouches[0];
            const dx = touch.clientX - start.x;
            const dy = touch.clientY - start.y;
            start = null;
            if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
            this.show(dx < 0 ? this.index + 1 : this.index - 1);
          });
        }

        moveIndicator() {
          const tab = this.tabs[this.index];
          if (!tab) return;
          this.tablist.style.setProperty('--indicator-x', `${tab.offsetLeft}px`);
          this.tablist.style.setProperty('--indicator-width', `${tab.offsetWidth}px`);
        }

        updateNav() {
          if (this.prev) this.prev.disabled = this.index === 0;
          if (this.next) this.next.disabled = this.index === this.panels.length - 1;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-reveal"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('text-reveal')) {
    customElements.define(
      'text-reveal',
      class TextReveal extends HTMLElement {
        connectedCallback() {
          this.heading = this.querySelector('.text-reveal__heading');
          this.lines = [...this.querySelectorAll('.text-reveal__line')].filter((line) => line.children.length);
          this.splitChars();
          this.fit();
          this.resizeObserver = new ResizeObserver(() => this.fit());
          this.resizeObserver.observe(this);

          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || window.Shopify?.designMode) {
            this.classList.add('is-done');
            return;
          }
          this.observer = new IntersectionObserver(
            ([entry]) => {
              if (!entry.isIntersecting) return;
              this.observer.disconnect();
              this.play();
            },
            { rootMargin: '0px 0px -20% 0px' }
          );
          this.observer.observe(this);
        }

        disconnectedCallback() {
          this.observer?.disconnect();
          this.resizeObserver?.disconnect();
        }

        splitChars() {
          this.querySelectorAll('.text-reveal__words').forEach((el) => {
            const text = el.textContent.trim();
            el.textContent = '';
            [...text].forEach((char) => {
              const span = document.createElement('span');
              span.className = 'text-reveal__char';
              span.textContent = char === ' ' ? ' ' : char;
              el.append(span);
            });
          });
        }

        fit() {
          this.heading.style.fontSize = '';
          const available = this.clientWidth;
          const style = getComputedStyle(this);
          const k = parseFloat(style.getPropertyValue('--k')) || 1;
          const imageWidth = (parseFloat(style.getPropertyValue('--image-width')) || 120) * k;
          const base = parseFloat(getComputedStyle(this.heading).fontSize);
          let scale = 1;
          this.lines.forEach((line) => {
            const words = [...line.querySelectorAll('.text-reveal__words')];
            const images = line.querySelectorAll('.text-reveal__image').length;
            const reserved = images * (imageWidth + 8);
            const textWidth = words.reduce((sum, el) => sum + el.scrollWidth, 0) + Math.max(0, words.length - 1) * 8;
            if (textWidth + reserved > available) scale = Math.min(scale, (available - reserved) / textWidth);
          });
          if (scale < 1) this.heading.style.fontSize = `${Math.floor(base * scale * 10) / 10}px`;
        }

        play() {
          this.lines.forEach((line) => {
            let cursor = 0;
            [...line.children].forEach((child) => {
              if (child.classList.contains('text-reveal__words')) {
                const chars = [...child.children];
                chars.forEach((char, i) => (char.style.transitionDelay = `${cursor + i * 0.04}s`));
                cursor += (chars.length - 1) * 0.04 + 0.6;
              } else if (child.classList.contains('text-reveal__image')) {
                const start = Math.max(0, cursor - 0.6);
                child.style.transitionDelay = `${start}s`;
                cursor = Math.max(cursor, start + 0.5);
              }
            });
          });
          requestAnimationFrame(() => this.classList.add('is-playing'));
          const total = Math.max(...this.lines.map((line) => line.querySelectorAll('.text-reveal__char').length)) * 0.04 + 1.5;
          setTimeout(() => {
            this.classList.add('is-done');
            this.classList.remove('is-playing');
            this.querySelectorAll('[style*="transition-delay"]').forEach((el) => (el.style.transitionDelay = ''));
          }, total * 1000);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
